var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgApiicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.26 10.5H15.26V11.5H13.26V10.5Z",
    fill: "#D83131"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20 4H4C3.46957 4 2.96086 4.21071 2.58579 4.58579C2.21071 4.96086 2 5.46957 2 6V18C2 18.5304 2.21071 19.0391 2.58579 19.4142C2.96086 19.7893 3.46957 20 4 20H20C20.5304 20 21.0391 19.7893 21.4142 19.4142C21.7893 19.0391 22 18.5304 22 18V6C22 5.46957 21.7893 4.96086 21.4142 4.58579C21.0391 4.21071 20.5304 4 20 4ZM8.4 15L8 13.77H6.06L5.62 15H4L6.2 9H7.82L10 15H8.4ZM16.76 11.5C16.7641 11.6981 16.7281 11.895 16.6541 12.0788C16.5802 12.2627 16.4699 12.4296 16.3298 12.5698C16.1896 12.7099 16.0227 12.8202 15.8388 12.8941C15.655 12.9681 15.4581 13.0041 15.26 13H13.26V15H11.76V9H15.26C15.4581 8.99591 15.655 9.03192 15.8388 9.10586C16.0227 9.17979 16.1896 9.29013 16.3298 9.43024C16.4699 9.57035 16.5802 9.73734 16.6541 9.92118C16.7281 10.105 16.7641 10.3019 16.76 10.5V11.5ZM20 15H18.5V9H20V15Z",
    fill: "#D83131"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.42999 12.77H7.58999L7.00999 11.18L6.42999 12.77Z",
    fill: "#D83131"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgApiicon);
export default __webpack_public_path__ + "static/media/apiicon.f81f6cd6b706e62f6e1c03eeb0073858.svg";
export { ForwardRef as ReactComponent };